import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import JsonLd from "../../components/base/JsonLd";
import { platforms, siteMeta } from "../../mocks/gossip";
import useSeo from "../../hooks/useSeo";

const BASE = "https://qihang77.cn";

const VALUES = [
  { icon: "ri-focus-3-fill", title: "一站聚合", desc: "六平台信源统一收录，你不用在微博、豆瓣、知乎之间来回奔波，来这里就能把整条瓜线看全。" },
  { icon: "ri-time-line", title: "持续追更", desc: "事件没有终点。我们为每个正在发酵的瓜保留进展时间线，重要后续绝不让你错过。" },
  { icon: "ri-scales-3-line", title: "理性吃瓜", desc: "爆料不等于真相。我们区分实锤、传闻与网友分析，克制评论，拒绝带节奏与人身攻击。" },
  { icon: "ri-shield-check-line", title: "保护边界", desc: "只转载公开信息，不跟拍、不打探隐私，有越界内容立即下线，守住网络讨论的基本礼貌。" },
];

const PRINCIPLES = [
  { t: "信源可溯", d: "每条内容都标注来源平台与作者，方便你回溯原帖、交叉求证。" },
  { t: "标签分层", d: "用「实锤 / 传闻 / 网友分析」明确可信度，避免把猜测当结论传播。" },
  { t: "更新透明", d: "事件反转或补充时，我们会在原帖下追加进展说明，不悄悄删帖掩盖。" },
  { t: "尊重为先", d: "讨论明星但不物化、不羞辱；批评作品不上升人身攻击。" },
];

const TESTIMONIALS = [
  { name: "追剧的Momo", role: "追更老用户", avatar: "m", text: "以前吃个瓜要在五个 App 之间来回切，还总漏掉后续。在这边看完整时间线，终于不用再拼碎片了。" },
  { name: "夜宵啃瓜人", role: "豆瓣原住民", avatar: "y", text: "每条都标了来源和可信度，这点最舒服。是传说还是实锤一眼就懂，不会被人带了节奏。" },
  { name: "通勤路上的K", role: "上班族", avatar: "k", text: "睡前刷一遍热搜榜就够，更新快还清爽。比较喜欢它那种把瓜讲清楚的劲儿，不故作高深。" },
];

export default function About() {
  useSeo({
    title: "关于我们-明星爆料 网站定位与内容原则",
    description:
      "了解明星爆料：我们是聚合微博、豆瓣、知乎、公众号、天涯与贴吧六大平台的明星娱乐资讯站。这里分享我们的网站定位、发展理念、内容原则与用户口碑，欢迎联系我们投稿线索或纠错。",
    keywords: "明星爆料,关于我们,网站定位,内容原则,联系爆料",
    path: "/about",
    type: "website",
  });

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于明星爆料",
    url: `${BASE}/about`,
    description: "明星爆料的品牌介绍、定位、理念与内容原则。",
  };

  return (
    <>
      <JsonLd data={aboutSchema} />
      <Navbar />
      <main className="bg-background-50 pt-16 md:pt-[72px]">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <nav aria-label="面包屑" className="py-5">
            <ol className="flex items-center gap-1.5 text-xs text-foreground-400">
              <li><Link to="/" className="hover:text-primary-600 whitespace-nowrap">首页</Link></li>
              <li aria-hidden="true"><i className="ri-arrow-right-s-line text-sm" /></li>
              <li className="text-foreground-700 whitespace-nowrap">关于我们</li>
            </ol>
          </nav>

          {/* 品牌介绍 */}
          <section className="relative rounded-3xl overflow-hidden bg-foreground-950 text-background-50 px-6 md:px-12 py-12 md:py-16">
            <div className="absolute -right-12 -top-12 w-64 h-64 rounded-full bg-primary-600/25 blur-3xl" aria-hidden="true"></div>
            <div className="absolute right-8 bottom-4 opacity-10 text-[160px] leading-none select-none" aria-hidden="true"><i className="ri-flashlight-fill"></i></div>
            <div className="relative max-w-3xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-600/20 text-primary-300 px-3 py-1 text-xs font-medium mb-5">
                <i className="ri-quill-pen-line" aria-hidden="true"></i> 关于我们
              </span>
              <h1 className="font-heading font-black text-3xl md:text-4xl leading-tight tracking-tight">把散落在全网的瓜，<br /><span className="text-accent-400">收进同一个篮子</span></h1>
              <p className="mt-5 text-background-200/85 leading-relaxed md:text-lg">
                {siteMeta.name}是一个专注娱乐圈明星资讯的聚合型内容站。我们相信，好的吃瓜体验不该是四处奔波、断章取义，而是「一站看到完整脉络」。
              </p>
              <p className="mt-4 text-background-200/70 leading-relaxed">
                为此，我们把微博热搜的第一手热度、豆瓣小组的时间线考据、知乎的深度拆解、公众号的长文复盘，以及天涯神帖与贴吧讨论里那些鲜活的声浪，统一汇入同一个信息流，再以清晰的分层和完整的脉络呈现给你。
              </p>
            </div>
          </section>

          {/* 网站定位 */}
          <section className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-8">
            <div className="md:col-span-7 rounded-2xl bg-background-100 p-6 md:p-8">
              <h2 className="font-heading font-bold text-foreground-950 text-xl mb-4 flex items-center gap-2.5">
                <span className="w-1.5 h-6 rounded-full bg-primary-500 inline-block" aria-hidden="true"></span> 我们是谁 · 在做什么
              </h2>
              <p className="text-foreground-700 leading-relaxed text-[15px]">
                我们是一群爱看剧、也爱聊剧的普通观众。白天可能各在各的岗位上，但一旦有好瓜，就会本能地开启「全网侦查模式」——先看微博有没有上热搜，再去豆瓣翻时间线，到知乎读长答案，刷公众号看复盘，最后去贴吧看看大家怎么吵。
              </p>
              <p className="text-foreground-700 leading-relaxed text-[15px] mt-4">
                渐渐地我们意识到，与其把时间浪费在切换平台和信息轰炸上，不如做一件事：把这些公开、可考的碎片信息聚合、梳理成一条条「可追溯」的完整故事线。
              </p>
              <p className="text-foreground-700 leading-relaxed text-[15px] mt-4">
                于是便有了{siteMeta.name}。我们不做第一手爆料，而做全网信息的「整理者」与「传声筒」，让每一位关心娱乐动态的朋友，都能用更少的力气、追到更完整的瓜。
              </p>
            </div>
            <div className="md:col-span-5 rounded-2xl bg-background-100 p-6 md:p-8">
              <h2 className="font-heading font-bold text-foreground-950 text-xl mb-5">覆盖平台</h2>
              <ul className="space-y-3">
                {platforms.map((p, i) => (
                  <li key={p.slug} className="flex items-center gap-3">
                    <span className="w-7 h-7 shrink-0 rounded-lg bg-primary-600 text-background-50 text-xs font-bold flex items-center justify-center">{i + 1}</span>
                    <span className="text-foreground-800 font-medium text-sm whitespace-nowrap">{p.name}</span>
                    <span className="flex-1 h-px bg-background-200"></span>
                    <span className="text-xs text-foreground-400 text-right">{p.blurb}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          {/* 发展理念 */}
          <section className="mt-12">
            <div className="text-center mb-8">
              <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">我们的四条价值观</h2>
              <p className="text-foreground-500 text-sm mt-2">它们决定了我们如何选题、如何写、以及如何与每一位读者相处</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {VALUES.map((v) => (
                <div key={v.title} className="rounded-2xl bg-background-100 p-6 hover:-translate-y-1 transition">
                  <span className="w-11 h-11 rounded-xl bg-accent-500 text-background-50 flex items-center justify-center mb-4">
                    <i className={`${v.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading font-bold text-foreground-900 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 内容原则 */}
          <section className="rounded-3xl bg-foreground-950 text-background-50 px-6 md:px-10 py-10 md:py-12 mt-12 relative overflow-hidden">
            <div className="absolute -left-10 -bottom-10 w-56 h-56 rounded-full bg-accent-500/20 blur-3xl" aria-hidden="true"></div>
            <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/20 text-accent-300 px-3 py-1 text-xs font-medium mb-4">
                  <i className="ri-shield-check-line" aria-hidden="true"></i> 内容原则
                </span>
                <h2 className="font-heading font-bold text-2xl md:text-3xl">我们如何负责地吃瓜</h2>
                <p className="text-background-200/80 text-sm mt-3 leading-relaxed">
                  吃瓜有趣，但要有底线。内容越热闹，越需要克制——这是我们对每一位读者的承诺，也是对每一个被讨论的人的尊重。
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {PRINCIPLES.map((p) => (
                  <div key={p.t} className="rounded-xl bg-background-50/10 border border-background-50/10 p-4">
                    <p className="font-heading font-bold text-accent-400 text-sm">{p.t}</p>
                    <p className="text-xs text-background-200/75 mt-1.5 leading-relaxed">{p.d}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* 用户口碑 */}
          <section className="mt-12">
            <div className="text-center mb-8">
              <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">听听吃瓜群众怎么说</h2>
              <p className="text-foreground-500 text-sm mt-2">来自不同平台用户的真实心声（示例反馈）</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {TESTIMONIALS.map((t) => (
                <figure key={t.name} className="rounded-2xl bg-background-100 p-6">
                  <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true"></i>
                  <blockquote className="text-foreground-700 text-sm leading-relaxed mt-2">{t.text}</blockquote>
                  <figcaption className="flex items-center gap-3 mt-5">
                    <span className="w-9 h-9 rounded-full bg-secondary-500 text-background-50 flex items-center justify-center font-bold uppercase">{t.avatar}</span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-900 whitespace-nowrap">{t.name}</span>
                      <span className="block text-xs text-foreground-400 whitespace-nowrap">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>

          {/* 联系方式 */}
          <section id="contact" className="scroll-mt-20 mt-12 mb-4">
            <div className="rounded-3xl bg-primary-600 text-background-50 px-6 md:px-10 py-10 md:py-12 relative overflow-hidden">
              <div className="absolute right-0 top-0 bottom-0 w-1/2 opacity-10" aria-hidden="true">
                <i className="ri-chat-3-line text-[220px]"></i>
              </div>
              <div className="relative max-w-2xl">
                <h2 className="font-heading font-bold text-2xl md:text-3xl">有瓜、有料、有问题？</h2>
                <p className="text-background-100 mt-3 leading-relaxed">
                  无论你想提供一条独家线索、对某条内容纠错，还是对我们的聚合方式有建议，都非常欢迎告诉我们。你的每次反馈，都会让这个吃瓜社区更清爽、更有价值。
                </p>
                <div className="flex flex-col sm:flex-row flex-wrap gap-4 mt-6">
                  <a href={`mailto:${siteMeta.email}`} className="inline-flex items-center gap-2 rounded-full bg-background-50 text-primary-700 px-5 py-3 text-sm font-medium hover:bg-background-100 whitespace-nowrap">
                    <i className="ri-mail-send-line text-base" aria-hidden="true"></i> {siteMeta.email}
                  </a>
                  <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-foreground-950 text-background-50 px-5 py-3 text-sm font-medium hover:bg-foreground-800 whitespace-nowrap">
                    <i className="ri-home-4-line text-base" aria-hidden="true"></i> 回到首页追瓜
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}